import type { Slide as PresentationSlide } from '../../../compatibility-overrides/presentation-types';
import { commonSlidePropertyKeys } from '../../common/constants';

export const presentationSlidePropertyKeys = [
  'slideId',
  'speakerNotes',
  'slideAdminKey',
  'slidePublicKey',
  'qrCodeVisibility',
  ...commonSlidePropertyKeys,
] as const satisfies Array<keyof PresentationSlide>;
